import { createScale } from '../internal';
import type { VitalParameterBounds } from '../types';

export const spo2Scale1Bounds: VitalParameterBounds = [
  {
    lower: 0,
    upper: 91,
    score: {
      type: 'low',
      value: 3,
    },
  },
  {
    lower: 92,
    upper: 93,
    score: {
      type: 'low',
      value: 2,
    },
  },
  {
    lower: 94,
    upper: 95,
    score: {
      type: 'low',
      value: 1,
    },
  },
  {
    lower: 96,
    upper: 100,
    score: {
      type: 'normal',
      value: 0,
    },
  },
];

/**
 * SpO2 (%) Scale 1 `integer`
 */
export const spo2Scale1 = createScale(spo2Scale1Bounds, 0);
